import { useEffect, useState } from "react"
import { RoutePath, useRoutesHooks } from "../../../../../features/routes"
import { O, PanelLoader, useGetCrumbs } from "../../../../../features/ui"
import { Product, ProductPrices } from "../../../state/types"
import { ProductForm } from "./productForm"
import { useProductPricesLoaders } from "../../../loaders/productPricesLoaders"
import { productHelpers } from "../../../hooks/productHooks"

export const ProductFormLoader = () => {
    const { dataType } = useRoutesHooks().parseUrl()
    const product = dataType as O<Product>

    const [ready, setReady] = useState(false)
    const [productPrices, setProductPrices] = useState<O<ProductPrices>>()

    const { describeProductCode } = productHelpers

    const productPricesLoaders = useProductPricesLoaders()

    const load = async () => {
        if (product) {
            const { loadProductPrices } = productPricesLoaders()
            const loadedPrices = await loadProductPrices(product.id)
            setProductPrices(loadedPrices)
        }
    }

    useEffect(() => {
        load().then(() => setReady(true))
    }, [])

    const productLabel = product ? `: ${describeProductCode(product) }` : ''
    const title = `${product ? 'Editar' : 'Crear'} Producto${productLabel}`
    const crumbs = useGetCrumbs(
        'Productos',
        RoutePath.PRODUCTS,
        product?.name,
        product?.id,
        product ? 'Editar' : 'Crear'
    )

    return (
        <PanelLoader
            title={title}
            crumbs={crumbs}
            ready={ready}
        >
            <ProductForm
                product={product}
                productPrices={productPrices}
            />
        </PanelLoader>
    )
}
